import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';

@Component({
  selector: 'app-manifest-viewer',
  templateUrl: './manifest-viewer.component.html',
  styleUrls: ['./manifest-viewer.component.scss']
})

export class ManifestViewerComponent extends BaseUnsubscribeComponent implements OnInit {

  @Input() data: any;
  public jsonText: string;
  constructor(public readonly modal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
    this.jsonText = JSON.stringify(this.data, null, 2).trim();
  }

  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }
}
